import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchOpen, setSearchOpen] = useState(false);
  const [navSearchQuery, setNavSearchQuery] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [expandedMenus, setExpandedMenus] = useState({});

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const toggleMenu = (menuName) => {
    setExpandedMenus(prev => {
      // Close all other menus and toggle the clicked one
      const newState = {};
      if (!prev[menuName]) {
        newState[menuName] = true;
      }
      return newState;
    });
  };

  // Close mobile menu and site search when route changes
  useEffect(() => {
    setMobileMenuOpen(false);
    setExpandedMenus({});
    setSearchOpen(false);
    setNavSearchQuery('');
  }, [location]);

  const runGlobalHealthSearch = () => {
    const q = String(navSearchQuery || '').trim();
    if (!q) return;
    /* Letter segment is ignored when ?search= is present; A keeps the route valid */
    navigate(`/diseases/A?search=${encodeURIComponent(q)}`);
    setSearchOpen(false);
    setNavSearchQuery('');
  };

  // Announcements data - can be moved to a config file or API later
  const announcements = [
    "🎉 Welcome to Tema General Hospital - Your Health, Our Priority",
    "📞 Emergency Services Available 24/7 - Call +233 30-330-2696/7",
    "💉 Book Your Vaccination Appointment Today",
    "🏥 New State-of-the-Art Equipment Now Available"
  ];

  // Social media links
  const socialLinks = {
    facebook: "https://www.facebook.com/share/1ZpbAkrnP8/",
    x: "https://x.com/temageneralhospital",
    tiktok: "https://www.tiktok.com/@temageneralhospitalhttps://www.tiktok.com/@temageneralhospit?_r=1&_t=ZS-95kUwJ95qiL",
    youtube: "https://www.youtube.com/temageneralhospital"
  };

  return (
    <>
      {/* Top Announcement Bar */}
      <div className="tgh-announcement-bar">
        <div className="container-fluid tgh-announcement-inner">
          <div className="row align-items-center tgh-announcement-row">
            {/* Sliding Announcements */}
            <div className="col-lg-8 col-md-7 col-12 tgh-announcement-slider-col">
              <div className="tgh-announcement-slider">
                <div className="tgh-announcement-track">
                  {announcements.map((announcement, index) => (
                    <div key={index} className="tgh-announcement-item">
                      {announcement}
                    </div>
                  ))}
                  {/* Duplicate for seamless loop */}
                  {announcements.map((announcement, index) => (
                    <div key={`duplicate-${index}`} className="tgh-announcement-item">
                      {announcement}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            
            {/* Social Media Icons */}
            <div className="col-lg-4 col-md-5 col-12 tgh-announcement-social-col">
              <div className="tgh-social-media">
                <a
                  href={socialLinks.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tgh-social-icon"
                  aria-label="Facebook"
                  title="Follow us on Facebook"
                >
                  <i className="bi bi-facebook"></i>
                </a>
                <a
                  href={socialLinks.x}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tgh-social-icon"
                  aria-label="X"
                  title="Follow us on X"
                >
                  <span style={{ fontWeight: 700, fontSize: '0.95rem', lineHeight: 1 }}>X</span>
                </a>
                <a
                  href={socialLinks.tiktok}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tgh-social-icon"
                  aria-label="TikTok"
                  title="Follow us on TikTok"
                >
                  <i className="bi bi-tiktok"></i>
                </a>
                <a
                  href={socialLinks.youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tgh-social-icon"
                  aria-label="YouTube"
                  title="Subscribe to our YouTube channel"
                >
                  <i className="bi bi-youtube"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Header - Tema General Hospital Style */}
      <nav className="tgh-main-header navbar navbar-expand-xl">
        <div className="container tgh-nav-container">
          {/* Logo */}
          <Link to="/" className="tgh-logo" aria-label="Tema General Hospital - Home">
            <img src="/img/tghlogo.png" alt="Tema General Hospital" className="tgh-logo-img" />
          </Link>

          {/* Navigation Links */}
          <div className="collapse navbar-collapse" id="mainNavbar">
            <ul className="navbar-nav mx-auto">
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  Care at TGH
                </a>
                <div className="dropdown-menu mega-menu">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-6">
                        <Link to="/about-us/overview" className="dropdown-item">
                          Patient-Centered Care
                        </Link>
                        
                        <Link to="/contact" className="dropdown-item">
                        Contact Us
                        </Link>
                        <Link to="/patient-visitor-guide" className="dropdown-item">
                          Patient & Visitor Guide
                        </Link>
                        
                      </div>
                      <div className="col-md-6">
                       
                        <Link to="/corporate" className="dropdown-item">
                          Health care access procedures
                        </Link>
                        <Link to="/departments-centers" className="dropdown-item">
                          Departments & Centers
                        </Link>
                        <Link to="/services" className="dropdown-item">
                          Our Services
                        </Link>
                        
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  Health Library
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/diseases" className="dropdown-item">
                      Diseases & Conditions
                    </Link>
                  </li>
                  <li>
                    <Link to="/tests-procedures" className="dropdown-item">
                      Tests & Procedures
                    </Link>
                  </li>
                  <li>
                    <Link to="/symptoms" className="dropdown-item">
                      Symptoms
                    </Link>
                  </li>
                  <li>
                    <Link to="/faq" className="dropdown-item">
                      FAQs
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  Our Services
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/services/general_care" className="dropdown-item">
                      General Care Services
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/specialized" className="dropdown-item">
                      Specialized Services
                    </Link>
                  </li>
                  <li>
                    <Link to="/services/diagnostic" className="dropdown-item">
                      Diagnostic Services
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  About Us
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/about-us/overview" className="dropdown-item">
                      Overview of TGH
                    </Link>
                  </li>
                  <li>
                    <Link to="/about-us/history" className="dropdown-item">
                      History & Background
                    </Link>
                  </li>
                  <li>
                    <Link to="/about-us/governance" className="dropdown-item">
                      Governance Structure
                    </Link>
                  </li>
                  <li>
                    <Link to="/about-us/senior-management" className="dropdown-item">
                      Senior Management
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  News & Media
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/news" className="dropdown-item">
                      TGH News
                    </Link>
                  </li>
                  <li>
                    <Link to="/blog" className="dropdown-item">
                      Blog
                    </Link>
                  </li>
                  <li>
                    <Link to="/events" className="dropdown-item">
                      Event
                    </Link>
                  </li>
                  <li>
                    <Link to="/gallery" className="dropdown-item">
                      Gallery
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <Link to="/projects" className="nav-link">
                  Projects & Ongoing Initiatives
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/support-tgh" className="nav-link">
                  Support Tema General Hospital
                </Link>
              </li>
            </ul>
          </div>

          {/* Utility Links - Right Side (search + hamburger on mobile) */}
          <div className="tgh-nav-utility d-flex align-items-center gap-2 gap-xl-3">
            <button
              className="tgh-utility-link border-0 bg-transparent p-0"
              onClick={() => setSearchOpen(!searchOpen)}
              aria-label="Search"
            >
              <i className="bi bi-search"></i>
            </button>
            <button
              className="tgh-menu-toggle d-xl-none border-0 bg-transparent"
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                setMobileMenuOpen(!mobileMenuOpen);
              }}
              aria-label="Toggle navigation menu"
            >
              {mobileMenuOpen ? (
                <i className="bi bi-x-lg fs-4" aria-hidden="true"></i>
              ) : (
                <i className="bi bi-list fs-4" aria-hidden="true"></i>
              )}
            </button>
          </div>
        </div>
      </nav>

      {/* Search Bar */}
      {searchOpen && (
        <div className="tgh-search-bar">
          <div className="container">
            <form
              className="input-group py-2"
              onSubmit={(e) => {
                e.preventDefault();
                runGlobalHealthSearch();
              }}
            >
              <input
                type="search"
                className="form-control form-control-lg"
                placeholder="Search diseases, conditions, symptoms..."
                autoFocus
                value={navSearchQuery}
                onChange={(e) => setNavSearchQuery(e.target.value)}
                aria-label="Search diseases and conditions"
              />
              <button className="btn btn-primary" type="submit">
                <i className="bi bi-search" aria-hidden="true"></i> Search
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Tema General  Style Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <>
          {/* Transparent Overlay Background */}
          <div 
            className="tgh-mobile-menu-backdrop"
            onClick={(e) => {
              // Only close if clicking directly on backdrop, not on menu panel
              if (e.target === e.currentTarget) {
                setMobileMenuOpen(false);
                setExpandedMenus({});
              }
            }}
            onTouchStart={(e) => {
              // Close on touch if touching the backdrop directly
              if (e.target === e.currentTarget) {
                setMobileMenuOpen(false);
                setExpandedMenus({});
              }
            }}
          />
          {/* Menu Panel that slides in from right */}
          <div 
            className="tgh-mobile-menu-panel"
            onClick={(e) => e.stopPropagation()}
            onTouchStart={(e) => e.stopPropagation()}
            onTouchMove={(e) => e.stopPropagation()}
          >
            {/* Header with Logo, Log in, Search, and Close Button */}
            <div className="tgh-mobile-menu-header">
            <div className="tgh-mobile-menu-logo">
              <img src="/img/tghlogo.png" alt="Tema General Hospital" className="tgh-mobile-logo-img" />
              <span className="d-none d-sm-inline">Tema General Hospital</span>
            </div>
            <div className="tgh-mobile-menu-header-actions">
              <button
                className="tgh-mobile-header-link border-0 bg-transparent p-0"
                onClick={() => {
                  setSearchOpen(true);
                  setMobileMenuOpen(false);
                }}
                aria-label="Search"
              >
                <i className="bi bi-search"></i>
              </button>
              <button 
                className="tgh-mobile-menu-close"
                onClick={() => setMobileMenuOpen(false)}
                aria-label="Close menu"
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>
          </div>

          {/* Blue Action Section */}
          <div className="tgh-mobile-menu-actions">
            <Link to="/donors-partners" className="tgh-mobile-action-box" onClick={() => setMobileMenuOpen(false)}>
              <i className="bi bi-heart-fill"></i>
              <span>Partners</span>
            </Link>
            <Link to="/diseases" className="tgh-mobile-action-box" onClick={() => setMobileMenuOpen(false)}>
              <i className="bi bi-heart-pulse"></i>
              <span>Diseases & Conditions</span>
            </Link>
            <Link to="/departments-centers" className="tgh-mobile-action-box" onClick={() => setMobileMenuOpen(false)}>
              <i className="bi bi-hospital"></i>
              <span>Find a Department</span>
            </Link>
          </div>

          {/* White Navigation Section */}
          <div className="tgh-mobile-menu-nav">
            {/* Care at TGH */}
            <div className="tgh-mobile-menu-item">
              <button 
                className="tgh-mobile-menu-toggle"
                onClick={() => toggleMenu('care')}
              >
                <span>Care at TGH</span>
                <i className={`bi bi-chevron-${expandedMenus.care ? 'up' : 'down'}`}></i>
              </button>
              {expandedMenus.care && (
                <div className="tgh-mobile-menu-submenu">
                  <Link to="/about-us/overview" onClick={() => setMobileMenuOpen(false)}>About TGH</Link>
                  <Link to="/contact" onClick={() => setMobileMenuOpen(false)}>Contact Us</Link>
                  <Link to="/patient-visitor-guide" onClick={() => setMobileMenuOpen(false)}>Patient & Visitor Guide</Link>
                  <Link to="/corporate" onClick={() => setMobileMenuOpen(false)}>Health care access procedures</Link>
                  <Link to="/departments-centers" onClick={() => setMobileMenuOpen(false)}>Departments & Centers</Link>
                  <Link to="/services" onClick={() => setMobileMenuOpen(false)}>Our Services</Link>
                </div>
              )}
            </div>

            {/* Health Library */}
            <div className="tgh-mobile-menu-item">
              <button 
                className="tgh-mobile-menu-toggle"
                onClick={() => toggleMenu('health')}
              >
                <span>Health Library</span>
                <i className={`bi bi-chevron-${expandedMenus.health ? 'up' : 'down'}`}></i>
              </button>
              {expandedMenus.health && (
                <div className="tgh-mobile-menu-submenu">
                  <Link to="/diseases" onClick={() => setMobileMenuOpen(false)}>Diseases & Conditions</Link>
                  <Link to="/tests-procedures" onClick={() => setMobileMenuOpen(false)}>Tests & Procedures</Link>
                  <Link to="/symptoms" onClick={() => setMobileMenuOpen(false)}>Symptoms</Link>
                  <Link to="/faq" onClick={() => setMobileMenuOpen(false)}>FAQs</Link>
                </div>
              )}
            </div>

            {/* Our Services */}
            <div className="tgh-mobile-menu-item">
              <button 
                className="tgh-mobile-menu-toggle"
                onClick={() => toggleMenu('services')}
              >
                <span>Our Services</span>
                <i className={`bi bi-chevron-${expandedMenus.services ? 'up' : 'down'}`}></i>
              </button>
              {expandedMenus.services && (
                <div className="tgh-mobile-menu-submenu">
                  <Link to="/services/general_care" onClick={() => setMobileMenuOpen(false)}>General Care Services</Link>
                  <Link to="/services/specialized" onClick={() => setMobileMenuOpen(false)}>Specialized Services</Link>
                  <Link to="/services/diagnostic" onClick={() => setMobileMenuOpen(false)}>Diagnostic Services</Link>
                </div>
              )}
            </div>

            {/* About Us */}
            <div className="tgh-mobile-menu-item">
              <button 
                className="tgh-mobile-menu-toggle"
                onClick={() => toggleMenu('about')}
              >
                <span>About Us</span>
                <i className={`bi bi-chevron-${expandedMenus.about ? 'up' : 'down'}`}></i>
              </button>
              {expandedMenus.about && (
                <div className="tgh-mobile-menu-submenu">
                  <Link to="/about-us/overview" onClick={() => setMobileMenuOpen(false)}>Overview of TGH</Link>
                  <Link to="/about-us/history" onClick={() => setMobileMenuOpen(false)}>History & Background</Link>
                  <Link to="/about-us/governance" onClick={() => setMobileMenuOpen(false)}>Governance Structure</Link>
                  <Link to="/about-us/senior-management" onClick={() => setMobileMenuOpen(false)}>Senior Management</Link>
                </div>
              )}
            </div>

            {/* News & Media */}
            <div className="tgh-mobile-menu-item">
              <button 
                className="tgh-mobile-menu-toggle"
                onClick={() => toggleMenu('news')}
              >
                <span>News & Media</span>
                <i className={`bi bi-chevron-${expandedMenus.news ? 'up' : 'down'}`}></i>
              </button>
              {expandedMenus.news && (
                <div className="tgh-mobile-menu-submenu">
                  <Link to="/news" onClick={() => setMobileMenuOpen(false)}>TGH News</Link>
                  <Link to="/blog" onClick={() => setMobileMenuOpen(false)}>Blog</Link>
                  <Link to="/events" onClick={() => setMobileMenuOpen(false)}>Event</Link>
                  <Link to="/gallery" onClick={() => setMobileMenuOpen(false)}>Gallery</Link>
                </div>
              )}
            </div>

            {/* Projects & Ongoing Initiatives */}
            <Link 
              to="/projects" 
              className="tgh-mobile-menu-link"
              onClick={() => setMobileMenuOpen(false)}
            >
              Projects & Ongoing Initiatives
            </Link>

            {/* Support Tema General Hospital */}
            <Link 
              to="/support-tgh" 
              className="tgh-mobile-menu-link"
              onClick={() => setMobileMenuOpen(false)}
            >
              Support Tema General Hospital
            </Link>
          </div>
          </div>
        </>
      )}
    </>
  );
}

export default Navbar;
